import {
  CookieConsentContext,
  CookieConsentConsumer,
  CookieConsentProvider
} from './cookie-consent-context';

export { CookieConsentContext, CookieConsentConsumer, CookieConsentProvider };

export default CookieConsentContext;
